import React from "react";
import eyeIcon from "../../assets/icons/eye.svg";
import clockIcon from "../../assets/icons/clock.svg";
import pulseIcon from "../../assets/icons/pulse.svg";

const StatsCards = ({ totalVisits, uniqueUsers, totalPages, trackResultsVisits, newTrackTraceVisits }) => {
  return (
    <div className="analytics-stats-grid">
      <div className="stat-card">
        <img src={eyeIcon} alt="" className="stat-card-icon" />
        <div className="stat-content">
          <p className="stat-label">Total Views</p>
          <h2 className="stat-value">{totalVisits.toLocaleString()}</h2>
          <p className="stat-subtitle">Today's page views</p>
        </div>
      </div>

      <div className="stat-card">
        <img src={clockIcon} alt="" className="stat-card-icon" />
        <div className="stat-content">
          <p className="stat-label">Total Users Today</p>
          <h2 className="stat-value">{uniqueUsers.toLocaleString()}</h2>
          <p className="stat-subtitle">Unique visitors today</p>
        </div>
      </div>

      <div className="stat-card">
        <img src={pulseIcon} alt="" className="stat-card-icon" />
        <div className="stat-content">
          <p className="stat-label">Total Pages</p>
          <h2 className="stat-value">{totalPages}</h2>
          <p className="stat-subtitle">Tracked pages</p>
        </div>
      </div>
{/* 
      <div className="stat-card">
        <div className="stat-content">
          <p className="stat-label">Track & Trace Views</p>
          <h2 className="stat-value">{trackResultsVisits.toLocaleString()}</h2>
          <p className="stat-subtitle">track & trace page visits</p>
        </div>
      </div> */}

      <div className="stat-card">
        <div className="stat-content">
          <p className="stat-label">Track & Trace Views</p>
          <h2 className="stat-value">{newTrackTraceVisits.toLocaleString()}</h2>
          <p className="stat-subtitle">track & trace page visits</p>
        </div>
      </div>
    </div>
  );
};

export default StatsCards;
